/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DipendenzaDTO } from './DipendenzaDTO';
import {
    DipendenzaDTOFromJSON,
    DipendenzaDTOFromJSONTyped,
    DipendenzaDTOToJSON,
    DipendenzaDTOToJSONTyped,
} from './DipendenzaDTO';

/**
 * 
 * @export
 * @interface ClienteDTO
 */
export interface ClienteDTO {
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    codiceFiscale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    partitaIva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    citta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    provinciaCodice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    provinciaDescrizione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    nazioneCodice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    nazioneDescrizione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    telefono?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    mobile?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    pec?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    codiceUnicocoSDI?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClienteDTO
     */
    formaGiuridicaId?: number;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    formaGiuridicaDescrizione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    pagmentoCodice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    pagmentoDescrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClienteDTO
     */
    listinoCodice?: number;
    /**
     * 
     * @type {string}
     * @memberof ClienteDTO
     */
    listinoDescrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClienteDTO
     */
    affidabilitaPunteggio?: number;
    /**
     * 
     * @type {number}
     * @memberof ClienteDTO
     */
    importoMinimoOrdine?: number;
    /**
     * 
     * @type {Array<DipendenzaDTO>}
     * @memberof ClienteDTO
     */
    dipendenze?: Array<DipendenzaDTO> | null;
}

/**
 * Check if a given object implements the ClienteDTO interface.
 */
export function instanceOfClienteDTO(value: object): value is ClienteDTO {
    return true;
}

export function ClienteDTOFromJSON(json: any): ClienteDTO {
    return ClienteDTOFromJSONTyped(json, false);
}

export function ClienteDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClienteDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'ragioneSociale': json['ragioneSociale'] == null ? undefined : json['ragioneSociale'],
        'codiceFiscale': json['codiceFiscale'] == null ? undefined : json['codiceFiscale'],
        'partitaIva': json['partitaIva'] == null ? undefined : json['partitaIva'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'cap': json['cap'] == null ? undefined : json['cap'],
        'citta': json['citta'] == null ? undefined : json['citta'],
        'provinciaCodice': json['provinciaCodice'] == null ? undefined : json['provinciaCodice'],
        'provinciaDescrizione': json['provinciaDescrizione'] == null ? undefined : json['provinciaDescrizione'],
        'nazioneCodice': json['nazioneCodice'] == null ? undefined : json['nazioneCodice'],
        'nazioneDescrizione': json['nazioneDescrizione'] == null ? undefined : json['nazioneDescrizione'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        'email': json['email'] == null ? undefined : json['email'],
        'pec': json['pec'] == null ? undefined : json['pec'],
        'codiceUnicocoSDI': json['codiceUnicocoSDI'] == null ? undefined : json['codiceUnicocoSDI'],
        'formaGiuridicaId': json['formaGiuridicaId'] == null ? undefined : json['formaGiuridicaId'],
        'formaGiuridicaDescrizione': json['formaGiuridicaDescrizione'] == null ? undefined : json['formaGiuridicaDescrizione'],
        'pagmentoCodice': json['pagmentoCodice'] == null ? undefined : json['pagmentoCodice'],
        'pagmentoDescrizione': json['pagmentoDescrizione'] == null ? undefined : json['pagmentoDescrizione'],
        'listinoCodice': json['listinoCodice'] == null ? undefined : json['listinoCodice'],
        'listinoDescrizione': json['listinoDescrizione'] == null ? undefined : json['listinoDescrizione'],
        'affidabilitaPunteggio': json['affidabilitaPunteggio'] == null ? undefined : json['affidabilitaPunteggio'],
        'importoMinimoOrdine': json['importoMinimoOrdine'] == null ? undefined : json['importoMinimoOrdine'],
        'dipendenze': json['dipendenze'] == null ? undefined : ((json['dipendenze'] as Array<any>).map(DipendenzaDTOFromJSON)),
    };
}

  export function ClienteDTOToJSON(json: any): ClienteDTO {
      return ClienteDTOToJSONTyped(json, false);
  }

  export function ClienteDTOToJSONTyped(value?: ClienteDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'ragioneSociale': value['ragioneSociale'],
        'codiceFiscale': value['codiceFiscale'],
        'partitaIva': value['partitaIva'],
        'indirizzo': value['indirizzo'],
        'cap': value['cap'],
        'citta': value['citta'],
        'provinciaCodice': value['provinciaCodice'],
        'provinciaDescrizione': value['provinciaDescrizione'],
        'nazioneCodice': value['nazioneCodice'],
        'nazioneDescrizione': value['nazioneDescrizione'],
        'telefono': value['telefono'],
        'mobile': value['mobile'],
        'email': value['email'],
        'pec': value['pec'],
        'codiceUnicocoSDI': value['codiceUnicocoSDI'],
        'formaGiuridicaId': value['formaGiuridicaId'],
        'formaGiuridicaDescrizione': value['formaGiuridicaDescrizione'],
        'pagmentoCodice': value['pagmentoCodice'],
        'pagmentoDescrizione': value['pagmentoDescrizione'],
        'listinoCodice': value['listinoCodice'],
        'listinoDescrizione': value['listinoDescrizione'],
        'affidabilitaPunteggio': value['affidabilitaPunteggio'],
        'importoMinimoOrdine': value['importoMinimoOrdine'],
        'dipendenze': value['dipendenze'] == null ? undefined : ((value['dipendenze'] as Array<any>).map(DipendenzaDTOToJSON)),
    };
}

